import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { type PropType } from 'vue';

import { modalType, type ModalType, modalVariant, type ModalVariant, ModalFooterVariant, type ModalFooterVariantType } from './modal-type-validators';
import ModalContent from './ModalContent.vue';
import ModalFooter from './ModalFooter.vue';
import ModalHeader from './ModalHeader.vue';
import modalService from './modals.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  /** false - to hide close icon and prevent closing the modal on background click  */
  canClose: { type: Boolean, default: true },
  title: { type: String },
  type: { type: String as PropType<ModalType>, default: modalType.base },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
  footerVariant: { type: String as PropType<ModalFooterVariantType>, default: ModalFooterVariant.default },
  wide: { type: Boolean, default: false },
},
  emits: ["modal-close"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const close = () => {
  if (props.canClose) {
    emit('modal-close');
    modalService.hide();
  }
};

const clear = () => {
  modalService.clear();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "modal",
    class: _normalizeClass(['modal', `modal--${__props.type}`, `modal--${__props.variant}`, { 'modal--wide': __props.wide }])
  }, [
    _createVNode(ModalHeader, {
      title: __props.title,
      type: __props.type,
      variant: __props.variant,
      "can-close": __props.canClose,
      onClosed: close
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header")
      ]),
      _: 3
    }, 8, ["title", "type", "variant", "can-close"]),
    _createVNode(ModalContent, {
      type: __props.type,
      variant: __props.variant
    }, {
      default: _withCtx(() => [
        (_ctx.$slots.content)
          ? _renderSlot(_ctx.$slots, "content", {
              key: 0,
              clear: clear
            })
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["type", "variant"]),
    (_ctx.$slots.buttons)
      ? (_openBlock(), _createBlock(ModalFooter, {
          key: 0,
          type: __props.type,
          variant: __props.footerVariant
        }, {
          default: _withCtx(({ itemClass }) => [
            _renderSlot(_ctx.$slots, "buttons", {
              clear: clear,
              itemClass: itemClass
            })
          ]),
          _: 3
        }, 8, ["type", "variant"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})